var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { useState } from "react";
import { useCompanyConfigQuery } from "../../../SWR/Company/useCompanyConfigQuery";
import { useNavigate } from "react-router-dom";
import { isValidUrl } from "./navigationUtils";
import { LoadingButton } from "@mui/lab";
export const OrderNowButton = (_a) => {
    var props = __rest(_a, []);
    const [loading, setLoading] = useState(false);
    const { doesCompanyHaveOrderPage, orderNowLink, navOrderButtonText } = useCompanyConfigQuery();
    const navigate = useNavigate();
    if (!doesCompanyHaveOrderPage) {
        return null;
    }
    function orderNowClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const orderNowLinkWithProtocol = orderNowLink.indexOf("http") === -1 ? `https://${orderNowLink}` : orderNowLink;
            if (!isValidUrl(orderNowLinkWithProtocol))
                return;
            setLoading(true);
            const currentUrl = new URL(window.location.href);
            const orderNowLinkUrl = new URL(orderNowLinkWithProtocol);
            const isSameBaseUrl = currentUrl.host === orderNowLinkUrl.host;
            const isOrderFlowLink = orderNowLinkUrl.pathname.includes("OrderFlow");
            if (isSameBaseUrl && isOrderFlowLink) {
                navigate(`${orderNowLinkUrl.pathname}${orderNowLinkUrl.search}`);
            }
            else {
                window.location.replace(orderNowLinkUrl.href);
            }
        });
    }
    return (_jsx(LoadingButton, Object.assign({ onClick: orderNowClick, variant: "outlined", color: "primary", loading: loading }, props, { children: _jsx(Typography, Object.assign({ variant: "h4", textTransform: "none" }, { children: navOrderButtonText })) })));
};
